// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/VWHeadWeb/VWHeadWeb-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/VWTextWeb/VWTextWeb-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

@font-face {
  font-family: 'AudiTypeVar-Normal';
  src: url("https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2") format("woff2-variations"),
}

@font-face {
  font-family: 'AudiType-Normal';
  font-style: normal;
  font-weight: normal;
  src: url("https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2") format("woff2-variations"),
}

@font-face {
  font-family: 'AudiType-ExtendedNormal';
  font-stretch: 130%;
  font-style: normal;
  font-weight: normal;
  src: url("https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2") format("woff2-variations"),
}

@font-face {
  font-family: 'AudiType-Bold';
  font-style: normal;
  font-weight: 700;
  src: url("https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2") format("woff2-variations"),
  }

@font-face {
  font-family: 'AudiType-ExtendedBold';
  font-stretch: 130%;
    font-style: normal;
    font-weight: 700;
    src: url("https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2") format("woff2-variations"),
  }

@font-face {
  font-family: 'VWHead-Bold';
  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWHeadWeb-Bold.woff2') format('woff2'),
}

@font-face {
  font-family: 'VWHead-Light';
  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWHeadWeb-Light.woff2') format('woff2'),
}

@font-face {
  font-family: 'VWHead-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
}

@font-face {
  font-family: 'VWText-Bold';
  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWTextWeb-Bold.woff2') format('woff2'),
}

@font-face {
  font-family: 'VWText-Light';
  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWTextWeb-Light.woff2') format('woff2'),
}

@font-face {
  font-family: 'VWText-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;8CAC4C;EAC5C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,iCAAiC;EACjC;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB;EACA;;AAEF;EACE,oCAAoC;EACpC,kBAAkB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB;EACF;;AAEF;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE,2BAA2B;EAC3B;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE,2BAA2B;EAC3B;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',\n    'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n@font-face {\n  font-family: 'AudiTypeVar-Normal';\n  src: url(\"https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2\") format(\"woff2-variations\"),\n}\n\n@font-face {\n  font-family: 'AudiType-Normal';\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2\") format(\"woff2-variations\"),\n}\n\n@font-face {\n  font-family: 'AudiType-ExtendedNormal';\n  font-stretch: 130%;\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2\") format(\"woff2-variations\"),\n}\n\n@font-face {\n  font-family: 'AudiType-Bold';\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2\") format(\"woff2-variations\"),\n  }\n\n@font-face {\n  font-family: 'AudiType-ExtendedBold';\n  font-stretch: 130%;\n    font-style: normal;\n    font-weight: 700;\n    src: url(\"https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2\") format(\"woff2-variations\"),\n  }\n\n@font-face {\n  font-family: 'VWHead-Bold';\n  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWHeadWeb-Bold.woff2') format('woff2'),\n}\n\n@font-face {\n  font-family: 'VWHead-Light';\n  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWHeadWeb-Light.woff2') format('woff2'),\n}\n\n@font-face {\n  font-family: 'VWHead-Regular';\n  src: url('./assets/fonts/VWHeadWeb/VWHeadWeb-Regular.woff2') format('woff2'),\n}\n\n@font-face {\n  font-family: 'VWText-Bold';\n  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWTextWeb-Bold.woff2') format('woff2'),\n}\n\n@font-face {\n  font-family: 'VWText-Light';\n  src: url('https://cdn.bronson.vwfs.tools/vw6/v/15.1.0/fonts/fonts/VWTextWeb-Light.woff2') format('woff2'),\n}\n\n@font-face {\n  font-family: 'VWText-Regular';\n  src: url('./assets/fonts/VWTextWeb/VWTextWeb-Regular.woff2') format('woff2'),\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
